import { makeActionCreator } from '../../config/store/utils'
import { getRegionalPurchasingMechanisms } from '../../services/regions'

const COLORS_DICTIONARY = {
  'Compra Ágil': 'teal',
  'Convenio Marco': 'ruby',
  'Licitación Privada': 'purpleHeart',
  'Licitación Pública': 'grape',
  'Sin Información': 'teal',
  'Trato Directo': 'dodgerBlue'
}

export const GET_REGIONAL_PURCHASING_MECHANISMS = 'GET_REGIONAL_PURCHASING_MECHANISMS'
export const GET_REGIONAL_PURCHASING_MECHANISMS_ERROR = 'GET_REGIONAL_PURCHASING_MECHANISMS_ERROR'
export const GET_REGIONAL_PURCHASING_MECHANISMS_SUCCESS = 'GET_REGIONAL_PURCHASING_MECHANISMS_SUCCESS'
export const onGetRegionalPurchasingMechanisms = makeActionCreator(GET_REGIONAL_PURCHASING_MECHANISMS)
export const onGetRegionalPurchasingMechanismsError = makeActionCreator(
  GET_REGIONAL_PURCHASING_MECHANISMS_ERROR,
  'payload'
)
export const onGetRegionalPurchasingMechanismsSuccess = makeActionCreator(
  GET_REGIONAL_PURCHASING_MECHANISMS_SUCCESS,
  'payload'
)
export const onGetRegionalPurchasingMechanismsThunk = payload => async dispatch => {
  dispatch(onGetRegionalPurchasingMechanisms())

  try {
    const { data = {} } = await getRegionalPurchasingMechanisms({ regionId: payload.regionId, year: payload.year })
    const enhancedData = data.payload?.map(datum => ({
      amount: datum.purchaseAmountCLP,
      amountUSD: datum.purchaseAmountUSD,
      colorName: COLORS_DICTIONARY[datum.purchaseModality],
      name: datum.purchaseModality,
      orders: datum.purchaseAmountNroOC,
      percentage: datum.percentageCLP
    }))
    const categories = enhancedData.map(datum => datum.name)
    const csv = [
      ['Mecanismo de compra', 'Nº de órdenes de compra', 'Monto total', 'Monto total (USD)'],
      ...enhancedData.map(datum => [datum.name, datum.orders, datum.amount, datum.amountUSD])
    ]

    return dispatch(onGetRegionalPurchasingMechanismsSuccess({ categories, csv, data: enhancedData }))
  } catch (error) {
    return dispatch(onGetRegionalPurchasingMechanismsError({ error }))
  }
}
